import { useState, useEffect, useRef } from "react";

import {
  addJobbIdCatalogue,
  updateType,
  getEquipmentForDropdown,
  getJobCardNo,
} from "../model/SBHeaderModel";

import {
  getSQ01AndSpBasket,
  getGlobalAndSpBasket,
} from "../model/MaterialSearchModel";
import { useToast } from "../../../../basecomp/components/provider/ToastProvider";

const SBHeaderVM = (props) => {
  const {
    startDate,
    finishDate,
    jobDirective,
    equipmentID,
    equipmentType,
    externalRef,
    jobType,
    section,
    resources,
    workDesc,
    setIsMaterialSearchUI,
    setIsShoppingBasketUI,
    setIsobDetailsUI,
    setIsReplenishmentUI,
    spDetails,
    spData,
    setSpData,
    setSpDetails,
  } = props;

  const [dropdownData, setDropdownData] = useState([]);
  const [jobCardNumber, setJobCardNumber] = useState("");
  const [catalogueId, setcatalogueId] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const { handleToastOpen } = useToast();

  const externalScriptRef = useRef();

  // Function to handle saving the job and reloading the page
  const handleSaveJob = async () => {
    if (!jobCardNumber || !jobDirective || !equipmentID || !equipmentType) {
      handleToastOpen(
        "error",
        "Please fill in all required fields - Job Directive, Equipment type, and Equipment Id."
      );
      return;
    }

    if (finishDate && startDate && finishDate <= startDate) {
      handleToastOpen("error", "Invalid date range!");
      return;
    }

    setIsLoading(true);
    const data = {
      id: jobCardNumber,
      reference_no: externalRef,
      job_directive: jobDirective,
      equipment_id: equipmentID,
      job_type: jobType,
      section: section,
      resources: resources,
      start_date_time: startDate,
      finish_date_time: finishDate,
      detail: workDesc,
    };

    try {
      const updateData = await updateType();
      if (updateData.status === 201) {
        const response = await addJobbIdCatalogue(data);
        if (response.status === 201) {

          setIsLoading(false);

          // Display success message
          handleToastOpen("success", "Data saved successfully");

          const keysToRemove = [
            "job_id",
            "sb_job_directive",
            "sb_external_ref",
            "sb_equipment_type",
            "sb_job_type",
            "sb_section",
            "sb_work_desc",
            "sb_resources",
            "sb_start_date_time",
            "sb_finish_date_time",
            "sb_equipment_id",
          ];

          keysToRemove.forEach((key) => {
            sessionStorage.removeItem(key);
          });

          // Wait for the toast to be displayed before reloading
          setTimeout(() => {
            window.location.reload();
          }, 1000); // 2000 milliseconds = 2 seconds
        }
      }
    } catch (error) {
      setIsLoading(false);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        const errorMessage = error.response.data.message;
        handleToastOpen("error", errorMessage);
      } else {
        handleToastOpen("error", error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };


  //Default Section : Get unique equipment_id and equipment_number for shopping basket dropdown
  const fetchDropdownData = async () => {
    try {
      const response = await getEquipmentForDropdown();
      setDropdownData(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchDropdownData();
  }, []);

  //Default Section :  Filter options for Equipment ID based on selected Equipment Type
  const filteredEquipmentIDs = dropdownData
    .filter((item) => !equipmentType || item.equipment_type === equipmentType)
    .map((item) => ({
      equipment_number: item.equipment_number,
      catalogue_id: item.catalogue_id,
    }));

  //Default Section : Filter options for Equipment Type based on selected Equipment ID
  const filteredEquipmentTypes = dropdownData
    .filter((item) => {
      if (!equipmentID) {
        return true; // Include all equipment types if no equipmentID is selected
      }
      // Include equipment types that match the selected equipmentID
      return item.equipment_number === equipmentID.equipment_number;
    })
    .map((item) => item.equipment_type);

  //Default Section : Generate new Job card number logic (Job Id Catalogue)
  const fetchJobCardNumber = async () => {
    try {
      const response = await getJobCardNo();
      const data = response.data;
      if (response.status === 200) {
        setJobCardNumber(parseInt(data.job_card_no, 10));
      } else {
        console.error(data.error);
      }
    } catch (error) {
      console.error("Error occurred during API request:", error);
    }
  };

  //Shopping Basket : Get all data from sp_basket_table by terminal_id  and type="SB" (Sp Basket)
  const fetchSpBasketAll = async () => {
    try {
      const data = await getSQ01AndSpBasket();
      if (data === undefined || (data && data.error === "Data not found")) {
        setSpDetails([]);
      } else {
        setSpDetails(data);
      }
    } catch (error) {
      console.error("Error fetching SP basket details:", error);
    }
  };
  useEffect(() => {
    fetchSpBasketAll();
  }, []);

  //D-Catalogue (most used): Fetch merge result of spbasket and ictsi data (Sp Basket, Global Data, Material Images)
  const fetchSpDataAll = async () => {
    try {
      const data = await getGlobalAndSpBasket();
      if (data === undefined || (data && data.error === "Data not found")) {
        setSpData([]);
      } else {
        const updatedData = data.map((obj) => ({
          ...obj,
          tableMode: "T",
        }));

        setSpData(updatedData);
      }
    } catch (error) {
      console.error("Error fetching SP basket details:", error);
    }
  };
  useEffect(() => {
    fetchSpDataAll();
  }, []);

  //Third party Tool
  const openEquipmentCatalogue = async () => {
    const usrtoken = localStorage.getItem("token");
    // Initialize externalScriptRef here
    externalScriptRef.current = window;
    // Wait for the 'layerLoaded' event
    window.addEventListener("layerLoaded", () => {
      setTimeout(function () {
        // Call setLayerCookie with the desired parameters
        externalScriptRef.current.setLayerCookie("user_token", usrtoken);
      }, 1000);
      console.log("Catalogue is present Akkkkkk");
    });
    externalScriptRef.current.openLayerByReleaseId(catalogueId, true);
  };

  useEffect(() => {
    console.log("catalogueId", catalogueId);

    if (catalogueId) {
      openEquipmentCatalogue();

      // Find the button element
      const closeButton = document.getElementById("close_tab_close_button");

      // Add click event listener
      closeButton.addEventListener("click", async () => {
        // Reload the page
        await new Promise((resolve) => setTimeout(resolve, 100)); // Optional delay for tasks to complete
        fetchSpDataAll();
        fetchSpBasketAll();
      });
    } else if (catalogueId === null) {

      // Retrieve the value from session storage
      const equipmentId = sessionStorage.getItem('sb_equipment_id');

      // Check if the value exists
      if (equipmentId) {
        handleToastOpen("error", "Catalogue not present");
      } else {
        console.log('Equipment ID:', equipmentId);
      }
    }
  }, [catalogueId, equipmentID]);

  useEffect(() => {
    fetchDropdownData();
    fetchJobCardNumber();
  }, []);


  const ShoppingBasket = () => {
    setIsMaterialSearchUI(true);
    setIsShoppingBasketUI(false);
    setIsobDetailsUI(false);
    setIsReplenishmentUI(false);
  };

  const MaterialSearch = () => {
    setIsMaterialSearchUI(false);
    setIsShoppingBasketUI(true);
    setIsobDetailsUI(false);
    setIsReplenishmentUI(false);
  };

  const JobDetails = () => {
    setIsMaterialSearchUI(false);
    setIsShoppingBasketUI(false);
    setIsobDetailsUI(true);
    setIsReplenishmentUI(false);
  };

  const Replenishment = () => {
    setIsMaterialSearchUI(false);
    setIsShoppingBasketUI(false);
    setIsobDetailsUI(false);
    setIsReplenishmentUI(true);
  };
  return {
    dropdownData,
    jobCardNumber,
    setJobCardNumber,
    spDetails,
    spData,
    setSpData,
    handleSaveJob,
    ShoppingBasket,
    MaterialSearch,
    JobDetails,
    Replenishment,
    filteredEquipmentIDs,
    filteredEquipmentTypes,
    setcatalogueId,
    isLoading,
    catalogueId
  };
};

export default SBHeaderVM;
